<style src="../css/head.css"></style>

<style src="../css/detail.css"></style>
<template>
  <div>
    <Head-section></Head-section>
    <div class="container">
      <div class="card">
        <div class="card-header">
          <ul class="nav nav-tabs card-header-tabs">
            <li class="nav-item">
              <a
                class="nav-link text-dark"
                href="#"
                :class="{active:foruid=='0'}"
                @click="getForumLs('',0)"
              >[{{$t("message.All")}}]</a>
            </li>
            
            <li class="nav-item" v-for="(item, idx)  in items" :key="idx">
              <a
                class="nav-link text-dark"
                href="#"
                :class="{active:foruid==item.id}"
                @click="getForumLs(item.id,0)"
              >[{{item.forumname}}]</a>
            </li>

             <li class="nav-item" v-if="!ismob"  style="float:right transparent;">
              <button type="button"  @click="toPost()" class="btn btn-danger my-2 my-sm-0" style="float:right transparent;">
                <i class="far fa-edit"></i>
                {{$t("message.POST")}}
              </button>
            </li>
          </ul>
           
        </div>
        

        <div class="card-body">
        <div class="card mt-3" v-if="ismob" style="border: 0px solid transparent;">
          <button type="button" @click="toPost()" class="btn btn-danger my-2 my-sm-0" style="float:right;">
            <i class="far fa-edit"></i>
            {{$t("message.POST")}}
          </button>
        </div>
          <div class="card mt-3" v-for="(item, idx) in items_content" :key="idx">
             <a :href="'/'+lan+'/topic/'+item.id"  target="_blank"  class="card-body text-dark">
              <table>
                <tbody>
                  <tr>
                    <td class="align-baseline align-middle">
                      <img :src="item.avatar" @error="imgReplace" class="rounded-circle whr_as_10" />
                    </td>
                    <td class="align-top align-middle">
                      <div>
                        <div>{{item.createby}}</div>
                        <span>{{item.createat | date}}</span>
                        <span
                          style="padding-left: 10px; color: #FF7200"
                        >{{item.comments}} {{$t("message.Reply")}}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h5 class="card-title">{{item.title}}</h5>
              <span slot="html" v-html="imgConvert(item.context)" v-if="item.video.length == 0"></span>
            </a>
            <div class="my_video" v-if="item.video.length != 0">
             <video-player
                    :options="vdOptions(item.video[0])"
                    class="nav-link"
                  />
            </div>
          </div>
        </div>
      </div>

      <nav aria-label="Page navigation example ">
        <ul class="pagination justify-content-center mt-3">
          <li class="page-item">
            <a class="page-link" href="#" @click="prePage()">{{$t("message.Previous")}}</a>
          </li>
          <!-- <li class="page-item" v-forv-for="(tt,idx) in total_pg" :key="tt" :class="{active:idx==pg}">
                <a class="page-link" href="#" @click="getForumLs(foruid,tt-1)">{{tt}}</a>
          </li>-->
          <li class="page-item" :class="{active:(page1-1)==pg}">
            <a class="page-link" href="#" @click="getForumLs(foruid,page1-1)">{{page1}}</a>
          </li>
          <li class="page-item" :class="{active:(page2-1)==pg}" v-if="total>1">
            <a class="page-link" href="#" @click="getForumLs(foruid,page2-1)">{{page2}}</a>
          </li>
          <li class="page-item" :class="{active:(page3-1)==pg}" v-if="total>2">
            <a class="page-link" href="#" @click="getForumLs(foruid,page3-1)">{{page3}}</a>
          </li>
          <li class="page-item" :class="{active:(page4-1)==pg}" v-if="total>3">
            <a class="page-link" href="#" @click="getForumLs(foruid,page4-1)">{{page4}}</a>
          </li>
          <li class="page-item" :class="{active:(page5-1)==pg}" v-if="total>4">
            <a class="page-link" href="#" @click="getForumLs(foruid,page5-1)">{{page5}}</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" @click="nextPage()">{{$t("message.Next")}}</a>
          </li>
        </ul>
      </nav>
    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner label="Loading..." variant="success" :class="{'d-none':spin_run}"></b-spinner>
    </div>
    </div>
    <Foot-Section></Foot-Section>
  </div>
</template>

<script>
import { mapActions,mapGetters } from "vuex";
import HeadSection from "./HeadSection.vue";
import FootSection from "./FootSection.vue";
import VideoPlayer from "@/components/VideoPlayer.vue";
export default {
  name: "Forum",
  components: { HeadSection, FootSection, VideoPlayer },
  data() {
    return {
      items: [],
      items_content: [],
      spin_run: false,
      foruid: "0",
      total: 0,
      total_pg: 5,
      pg: 0,
      page1: 1,
      page2: 2,
      page3: 3,
      page4: 4,
      page5: 5,
      videoOptions: {
        autoplay: true,
        controls: true,
        sources: [
          {
            src: "/path/to/video.mp4",
            type: "video/mp4"
          }
        ]
      }
    };
  },
  created() {
    let language = this.$route.params.language;
      if(this.$store.state.lan_array.indexOf(language) == -1){
        this.toHome();
      }
    this.getForumType();
    this.getForumLs("0", 0);
  },
   computed: mapGetters(["lan", "lan_array", "ismob"]),
      watch: {
      lan(oldlan, newlan) {
         this.getForumType();
    this.getForumLs("0", 0);
      }
    },
  methods: {
    ...mapActions({
      getForumType(dispatch) {
        dispatch("getForumType", {}).then(data => {
          if (data.result) {
            this.items = data.items;
          }
        });
      },
      getForumLs(dispatch, foruid, pg) {
        this.foruid = foruid;
        this.pg = pg;
        let pgs = 20;
        this.spin_run = false;
        dispatch("getForumLs", { foruid, pg, pgs }).then(data => {
          this.spin_run = data.result;
          if (data.result) {
            this.total = Math.ceil(data.total / 20);
            if (this.total <= 5) {
              this.total_pg = this.total;
            }
            this.items_content = data.items;
          }
        });
      }
    }),

    vdOptions(url) {
      this.videoOptions.autoplay = false;
      this.videoOptions.controls = true;
      this.videoOptions.sources[0].src = url;
      this.videoOptions.width = '100%';
      this.videoOptions.sources[0].type = "application/x-mpegURL";

      return this.videoOptions;
    },

    imgReplace(e) {
      e.target.src =
        "https://bluedio.com/img/2019/01/05/25d40416e9b64d2a8a39aba3affaece7.jpg";
    },
    imgConvert(ctx) {
      let ctx2 = ctx.replace(/<img/g, '<img class="img-fluid"');
      let ctx1 = ctx2.replace(/white-space: nowrap;/g, "");
      return ctx1.replace(/<span/g, '<span class="text-justify"');
    },
    nextPage() {
      if (this.pg + 1 >= this.total) return;
      if (this.pg < this.page5 - 1) {
        this.getForumLs(this.foruid, this.pg + 1);
      } else {
        this.page1 = this.page1 + 5;
        this.page2 = this.page2 + 5;
        this.page3 = this.page3 + 5;
        this.page4 = this.page4 + 5;
        this.page5 = this.page5 + 5;
        this.getForumLs(this.foruid, this.pg + 1);
      }
    },
    prePage() {
      if (this.pg <= 0) return;
      if (this.pg < this.page1 - 1) {
        this.getForumLs(this.foruid, this.pg - 1);
      } else {
        this.page1 = this.page1 - 5;
        this.page2 = this.page2 - 5;
        this.page3 = this.page3 - 5;
        this.page4 = this.page4 - 5;
        this.page5 = this.page5 - 5;
        this.getForumLs(this.foruid, this.pg - 1);
      }
    },
   
    toCommentdetail(id) {
      this.$router.push({
        name: "enCommentDetail",
        params: { commentdetailid: id }
      });
    },
    
   toPost() {
      if (this.access_token == "") {
        this.showToast(this.$t("message.You_logout"));
        return;
      }
      this.$router.push({
        name: "post",
        params:{
          language:this.lan
        }
      });
    },
    toHome() {
      let nameHome = this.lan + "home";
      this.$router.replace({
        name: nameHome
      });
    },
  }
};
</script>

<style>
  .my_video{
    width: 100%;
    height: 100%;
    background-color: white;
  }
  .video-js{
    width:100%;
    height:0;
    padding-bottom:56.25%;
  }

</style>

